import Component from '../Component';

export default class AgeChecker extends Component {
    STORAGE_KEY = 'wetheme-age-check';

    constructor(theme, element) {
      super(theme, element);

      this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
      this.ageDelay = 0;
      this.ageTestMode = this.element.dataset.ageTestMode === 'true';
      this.modalPrompt = document.getElementById('verification__prompt');
      this.popupCloseBtn = this.element.querySelector('.verification-popup__close-button');
      this.denyContent = this.element.querySelector('.modal-deny-content');
      this.initialContent = this.element.querySelector('.modal-initial-content');
      this.initialBtns = this.initialContent.querySelectorAll('button');
      this.denyBtns = this.denyContent.querySelectorAll('button');
      this.hiddenClass = 'hidden';

      this.load();
    }

    setTabindex = (elements, val) => {
      for (const el of elements) {
        el.setAttribute('tabIndex', val);
      }
    }

    resetModal = () => {
      this.modalPrompt.scrollTop = 0;

      this.popupCloseBtn.classList.remove('d-block');
      this.initialContent.classList.remove(this.hiddenClass);
      this.denyContent.classList.add(this.hiddenClass);

      this.setTabindex(this.initialBtns, '1');
      this.setTabindex(this.denyBtns, '-1');

      this.trapFocus();
    }

    trapFocus = () => {
      var self = this;

      setTimeout(function(){
        if (self.element) {
          var inputs = self.element.querySelectorAll('button:not([tabindex="-1"]), a:not([tabindex="-1"])');
          var firstInput;
          var lastInput;

          if (inputs[0].tagName == 'A') {
            firstInput = /** @type {HTMLAnchorElement} */ (inputs[0]);
          } else if (inputs[0].tagName == 'BUTTON') {
            firstInput = /** @type {HTMLButtonElement} */ (inputs[0]);
          }

          if (inputs[0].tagName == 'A') {
            lastInput = /** @type {HTMLAnchorElement} */ (inputs[inputs.length - 1]);
          } else if (inputs[0].tagName == 'BUTTON') {
            lastInput = /** @type {HTMLButtonElement} */ (inputs[inputs.length - 1]);
          }

          /*set focus on first input*/
          self.element.focus();

          /*redirect last tab to first input*/
          lastInput.addEventListener('keydown', (/** @type {KeyboardEvent} */ e) => {
            if ((e.code === 'Tab' && !e.shiftKey)) {
              e.preventDefault();
              firstInput.focus();
            }
          })

          /*redirect first shift+tab to last input*/
          firstInput.addEventListener('keydown', (event) => {
            const e =  /** @type {KeyboardEvent} */ (event);

            if ((e.code === 'Tab' && e.shiftKey)) {
              e.preventDefault();
              lastInput.focus();
            }
          });
        }
      }, 1000);
    }
    load = () => {
      var self = this;

      if (this.ageTestMode) {
        // age checker is in test mode - will show immediately in editor and on live site
        this.element.classList.add('d-block');

        this.trapFocus();
      }

      const enterButton = document.getElementById('button__enter');
      const exitButton = document.getElementById('button__exit');
      const returnButton = document.getElementById('button__return');
      const modalLinks = this.element.querySelector('.modal-content__wrapper a');

      if (modalLinks) {
        modalLinks.setAttribute("tabindex", "1");
      }

      function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
      }

      var isAnAdult = readCookie('isAnAdult');
      if (!isAnAdult) {
        this.element.classList.add('d-block');
        this.trapFocus();
      }

      if (enterButton) {
        enterButton.addEventListener('click', function(){
          document.write("<style> #prompt__background { display: none; }</style>");
          document.cookie = "isAnAdult=true; expires=0; path=/";
          location.reload();
        });
      }

      if (exitButton) {
        exitButton.addEventListener('click', function(){
          self.modalPrompt.scrollTop = 0;
          self.popupCloseBtn.classList.add('d-block');
          self.denyContent.classList.remove(self.hiddenClass);
          self.initialContent.classList.add(self.hiddenClass);

          self.setTabindex(self.initialBtns, '-1');
          self.setTabindex(self.denyBtns, '1');

          self.trapFocus();
        });
      }

      if (returnButton) {
        returnButton.addEventListener('click', function(){
          self.resetModal();
        });
      }

      if (this.popupCloseBtn) {
        this.popupCloseBtn.addEventListener('click', function(){
          self.resetModal();
        });
      }
    }
}
